import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';

export const CONNECT_METAMASK = 'CONNECT_METAMASK';
export const CONNECT_METAMASK_WITH_SIGNING = 'CONNECT_METAMASK_WITH_SIGNING';
export const INSTALL_METAMASK = 'INSTALL_METAMASK';
export const AUTH_LOGIN = authModalLoader.constants.LOGIN;
export const AUTH_REGISTER = authModalLoader.constants.REGISTER;
export const AUTH_CREATE_PW = authModalLoader.constants.REQUEST_PASSWORD_EMAIL;
export const UNSUPPORTED_BROWSER = 'UNSUPPORTED_BROWSER';
export const UNSUPPORTED_CHAIN = 'UNSUPPORTED_CHAIN';
export const MISMATCHED_ADDRESS = 'MISMATCHED_ADDRESS';

export type ContentType =
    | typeof CONNECT_METAMASK
    | typeof CONNECT_METAMASK_WITH_SIGNING
    | typeof INSTALL_METAMASK
    | typeof AUTH_LOGIN
    | typeof AUTH_REGISTER
    | typeof AUTH_CREATE_PW
    | typeof UNSUPPORTED_BROWSER
    | typeof UNSUPPORTED_CHAIN
    | typeof MISMATCHED_ADDRESS;
